"use client";

import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { useTenantData } from "@/hooks/shared/useTenantData";
import { EntryType, MediaGroup } from "@/openapi/generated/models";
import { invalidateTeacherMediaQueries } from "@/lib/utils/media/invalidate-teacher-media-queries";
import { useMediaAssetGet } from "./useMediaAssetGet";

export function useTeacherPublicProfileImage(
  teacherId: number,
  options?: { enabled?: boolean },
) {
  const queryClient = useQueryClient();
  const { tenantId } = useTenantData();
  const isValid = tenantId > 0 && teacherId > 0;

  const { url, isFetching, refetch } = useMediaAssetGet(
    {
      tenantId,
      ownerType: EntryType.Teacher,
      ownerId: teacherId,
      mediaGroup: MediaGroup.Profile,
    },
    {
      enabled: options?.enabled !== false && isValid,
      requireAuth: false,
    },
  );

  const refreshImage = useCallback(() => {
    return invalidateTeacherMediaQueries(queryClient, tenantId, teacherId);
  }, [queryClient, tenantId, teacherId]);

  return {
    url,
    isFetching,
    refetch,
    refreshImage,
  };
}
